// extracted by mini-css-extract-plugin
export default {"requiredSymbol":"RequiredSymbol_requiredSymbol__ylfmZ"};